import React from 'react';
import { Cell } from 'react-table';
import cx from 'classnames';

interface Props {
    cell: Cell<DetectionTrack>;
}

const formatter = new Intl.DateTimeFormat('en', { calendar: 'gregory' });

/**
 * Displays the date that detection was enabled, if it is currently enabled. The date is formatted
 * like: 5/12/2020. If the row contains a detection status update that is in draft mode, the text
 * will be gray.
 * @param Props must contain a `cell.value` which is either a string or number that can be used to
 * instantiate a JavaScript Date. Usually this will be an AWSDateTime, which is an ISO8601 date
 * string.
 */
export const DetectionStartCell = ({ cell }: Props): JSX.Element | string => {
    const {
        value: { detectionStartDate, draft },
    } = cell;

    let label = '';

    if (detectionStartDate) {
        label = formatter.format(detectionStartDate);
    }

    return (
        <div
            className={cx('px-1', {
                'text-tertiary-400': draft,
            })}
        >
            {label}
        </div>
    );
};
